import React from 'react';
import { XIcon, CheckCircleIcon } from 'lucide-react';
interface SuccessModalProps {
  onClose: () => void;
  title?: string;
  message?: string;
}
export function SuccessModal({
  onClose,
  title = 'Payment Processed',
  message = "The customer's card has been successfully charged."
}: SuccessModalProps) {
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-2703">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4" data-id="element-2704">
        <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-2705">
          <h3 className="text-lg font-medium text-gray-800" data-id="element-2706">{title}</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500" data-id="element-2707">
            <XIcon size={20} data-id="element-2708" />
          </button>
        </div>
        <div className="p-6 flex flex-col items-center" data-id="element-2709">
          <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mb-4" data-id="element-2710">
            <CheckCircleIcon size={32} className="text-green-600" data-id="element-2711" />
          </div>
          <p className="text-center text-gray-600 mb-4" data-id="element-2712">{message}</p>
          <button onClick={onClose} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-2713">
            Done
          </button>
        </div>
      </div>
    </div>;
}